
import { LocalDate, ZonedDateTime } from "@js-joda/core";
import { ApprovalMethod, TaskSchoolInfo } from "../domain/restriction.domain";
export interface CreateTaskDefinitionRequest {
  title: string;
  description: string;
  approvalMethod?: ApprovalMethod;
  taskSchoolInfo?: TaskSchoolInfo;
  repeatSelectedDays: Array<number>;
  startAt: ZonedDateTime;
  endAt: ZonedDateTime;
  createdBy?: string;
  followedBy?: string[];
  validityStartDate?: ZonedDateTime;
  validityEndDate?: ZonedDateTime;
}
export interface ModifyTaskDefinitionRequest extends CreateTaskDefinitionRequest {
  taskDefinitionId: string;
  whatToModify: TaskDefinitionModifyType;
  deactivationDate: ZonedDateTime;
}
export interface CancelTaskRequest {
  taskDefinitionId: string, 
  taskExecutionId?: string
  taskExecutionStatus?: string; // Added to differentiate between pending and in-progress tasks
  deactivate?: boolean; 
  deactivateFromDate?: LocalDate;
  dateToCancel?: LocalDate; 
  repeatSelectedDays?: number[];
}

export enum TaskDefinitionModifyType {
  THIS_OCCURENCE = "THIS_OCCURENCE",
  FUTURE_OCCURENCE = "FUTURE_OCCURENCE"
}